import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgChat = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M5 4.5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h2.667a1 1 0 0 1 .707.293l3.293 3.293 3.293-3.293a1 1 0 0 1 .707-.293h2.666a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3zm-3.536-.536A5 5 0 0 1 5 2.5h13.333a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-2.252l-3.707 3.707a1 1 0 0 1-1.415 0L7.253 20.5H5a5 5 0 0 1-5-5v-8a5 5 0 0 1 1.464-3.536"
      fill={props.color}
      fillRule="evenodd"
    />
    <Path
      clipRule="evenodd"
      d="M5.333 8.832a1 1 0 0 1 1-1H17a1 1 0 1 1 0 2H6.333a1 1 0 0 1-1-1M6.667 14.164a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgChat);
export default Memo;
